import { Injectable } from "@angular/core"
import { BankingAccount } from "../meta/BankingAccount.interface"
import { BillingAddress } from "../meta/BillingAddress.interface"
import { BehaviorSubject } from "rxjs"
import { INITIAL_BANKING_ACCOUNT } from "../meta/initial-banking-account.const"
import { INITIAL_BILLING_ADDRESS } from "../meta/initial-billing-address.const"

@Injectable({
  providedIn: "root"
})
export class BillingDataService {
  private readonly _bankingAccount$ = new BehaviorSubject<BankingAccount>(INITIAL_BANKING_ACCOUNT)
  private readonly _billingAddress$ = new BehaviorSubject<BillingAddress>(INITIAL_BILLING_ADDRESS)

  public getBankingAccount(): BankingAccount {
    return this._bankingAccount$.getValue()
  }

  public getBillingAddres(): BillingAddress {
    return this._billingAddress$.getValue()
  }

  public setBankingAccount(bankingAccount: Partial<BankingAccount>): void {
    this._bankingAccount$.next({
      ...this._bankingAccount$.getValue(),
      ...bankingAccount
    })
  }

  public setBillingAddress(billingAddress: Partial<BillingAddress>): void {
    this._billingAddress$.next({
      ...this._billingAddress$.getValue(),
      ...billingAddress
    })
  }
}
